import { toast } from 'react-toastify';

import { find as findLodash, isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestEstoqueTanques({ payload }) {
  try {
    const params = { ...payload.params };

    const wherefield = params.wherefield || [];
    const valuewherefield = params.valuewherefield || [];
    const typewherefield = params.typewherefield || [];

    if (params.wherefield) {
      params.wherefield = [
        ...wherefield,
        'statustanquefisico',
        'exibeestoquetanquefisico',
      ];
      params.valuewherefield = [...valuewherefield, 'L', 'S'];
      params.typewherefield = [...typewherefield, 'EQUALS', 'EQUALS'];
    } else {
      params.wherefield = ['statustanquefisico', 'exibeestoquetanquefisico'];
      params.valuewherefield = ['L', 'S'];
      params.typewherefield = ['EQUALS', 'EQUALS'];
    }

    const response = yield call(api.get, 'estoquestanquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteEstoqueTanque({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `estoquestanquespostoscomboios/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'estoquestanquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/estoquetanque');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `estoquestanquespostoscomboios/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'estoquestanquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/estoquetanque');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const params = { ...payload.params };

    const wherefield = params.wherefield || [];
    const valuewherefield = params.valuewherefield || [];
    const typewherefield = params.typewherefield || [];

    if (params.wherefield) {
      params.wherefield = [
        ...wherefield,
        'statustanquefisico',
        'exibeestoquetanquefisico',
      ];
      params.valuewherefield = [...valuewherefield, 'L', 'S'];
      params.typewherefield = [...typewherefield, 'EQUALS', 'EQUALS'];
    } else {
      params.wherefield = ['statustanquefisico', 'exibeestoquetanquefisico'];
      params.valuewherefield = ['L', 'S'];
      params.typewherefield = ['EQUALS', 'EQUALS'];
    }

    const response = yield call(api.get, 'estoquestanquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaoestoquetanque/ESTOQUETANQUES_IN_REQUEST',
    requestEstoqueTanques
  ),
  takeLatest('@operacaoestoquetanque/DELETE_ESTOQUEPOSTO', deleteEstoqueTanque),
  takeLatest('@operacaoestoquetanque/SUCCESS_REMOVE', requestEstoqueTanques),
  takeLatest('@operacaoestoquetanque/STORE_ESTOQUEPOSTO', store),
  takeLatest('@operacaoestoquetanque/FIND_ESTOQUEPOSTO', find),
  takeLatest('@operacaoestoquetanque/UPDATE_ESTOQUEPOSTO', update),
  takeLatest('@operacaoestoquetanque/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaoestoquetanque/RESET_FILTERING', applyedFilters),
]);
